import mainNavigationStyle from './styles/mainNavigation.module.scss'

const brand = {
  key: 'default',
  logoMark: {
    fillColor: 'white',
    logoKey: 'realhub',
  },
  styles: {
    mainNavigation: mainNavigationStyle,
  },
  title: 'Default',
}

export default brand
